var _defs, _path, _line, _line2, _line3, _line4, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke:#7F7F7F;stroke-width:3px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.40816,8.5h5.54592A5.80345,5.80345,0,0,1,46.5,14.5v26a6.01764,6.01764,0,0,1-6,6H7.5a6.01764,6.01764,0,0,1-6-6v-26a5.91385,5.91385,0,0,1,5.78723-6h5.78724"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.00001,
    y1: 8.5,
    x2: 30.54851,
    y2: 8.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.54852,
    y1: 20,
    x2: 41,
    y2: 20
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.17158,
    y1: 32.88389,
    x2: 21.35355,
    y2: 36.06586
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.6967,
    y1: 36.06586,
    x2: 29.82842,
    y2: 27.93414
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M16,3V9H14V3h2m0-3H14a3.00883,3.00883,0,0,0-3,3V9a3.00883,3.00883,0,0,0,3,3h2a3.00881,3.00881,0,0,0,3-3V3a3.00881,3.00881,0,0,0-3-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M34,3V9H32V3h2m0-3H32a3.00883,3.00883,0,0,0-3,3V9a3.00883,3.00883,0,0,0,3,3h2a3.00883,3.00883,0,0,0,3-3V3a3.00883,3.00883,0,0,0-3-3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/Activity_Icon.32ead5ff3081f594fd3073215bba387c.svg";
export { ForwardRef as ReactComponent };